// extracted by mini-css-extract-plugin
export default {"button":"tbvIalRdvvCLTO8ozbnasA==","content":"aHHY9usxeHo622+grHll9w==","qr":"qpGcEtNR88wgLOcPwl-30g=="};